// Shared validation schema for `api_name` fields on ObjectType and PropertyType.
// Convention: lowercase snake_case — must start with a lowercase letter, followed by
// zero or more lowercase letters, digits, or underscores.
// Examples: "vendor" ✓   "vendor_id" ✓   "line_item_2" ✓
//           "Vendor" ✗   "2vendor" ✗   "vendor-name" ✗   "vendor name" ✗

import { z } from "zod";

export const API_NAME_REGEX = /^[a-z][a-z0-9_]*$/;

export const API_NAME_ERROR_MESSAGE =
  "Must start with a letter and contain only lowercase letters, digits, underscores (e.g. vendor_id)";

export const apiNameSchema = z
  .string()
  .min(1, "API name is required")
  .regex(API_NAME_REGEX, { message: API_NAME_ERROR_MESSAGE });
